import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {EventCallbackFunction, PlotLineOrBand} from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class FrequencyViewChartService {
  private mouseEventPlotLineOrBand = new Subject<EventCallbackFunction<PlotLineOrBand>>();

  getMouseEventPlotLineOrBand(): Observable<EventCallbackFunction<PlotLineOrBand>> {
    return this.mouseEventPlotLineOrBand.asObservable();
  }

  setMouseEventPlotLineOrBand(mouseEventPlotLineOrBand: EventCallbackFunction<PlotLineOrBand>): void {
    this.mouseEventPlotLineOrBand.next(mouseEventPlotLineOrBand);
  }
}
